import { put, takeLatest, call } from 'redux-saga/effects';
import { fetchAmenitiesSuccess } from '../actions';
import ActionTypes from '../constants';
import { coreAPI } from 'utils/request';
import { showErrorNotification } from '@aha/utils';

export function* doFetchAmenities() {
  try {
    const { data } = yield call(coreAPI.get, '/v1/pms/amenities');

    yield put(fetchAmenitiesSuccess(data));
  } catch (err) {
    showErrorNotification('Fail to fetch', err);
  }
}

export default function* watchFetchCities() {
  yield takeLatest(ActionTypes.FETCH_AMENITIES, doFetchAmenities);
}
